import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="bg-[#1A2744] text-white py-20 px-5" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-12 items-center" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-44 h-44 rounded-full overflow-hidden mx-auto shadow-[0_15px_40px_rgba(0,0,0,0.3)] border-4 border-[#F4A535]" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/amFJJDW22A3AtUwZgMpv2b/bajaresolu.png" alt="Foto de la autora" className="w-full h-full object-cover" data-id="element-18" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center md:text-left" data-id="element-19">
            <div className="inline-block text-xs font-bold tracking-[3px] uppercase text-[#F4A535] mb-3" data-id="element-20">
              Sobre la autora
            </div>
            <h2 className="text-3xl md:text-4xl mb-4" data-id="element-21">
              Una voz que entiende a las familias
            </h2>
            <p className="text-base text-[#B8C8E8] leading-relaxed mb-4" data-id="element-22">
              Esta guía nació de años de acompañar a familias en los momentos
              más desafiantes de la crianza. Basada en investigaciones de
              neurociencia del desarrollo, psicología familiar y comunicación
              efectiva de autores como Laurence Steinberg, Frances Jensen, John
              Gottman y Diana Baumrind.
            </p>
            <p className="text-base text-[#B8C8E8] leading-relaxed" data-id="element-23">
              No es un libro académico. Es la guía que deseamos que alguien nos
              hubiera dado cuando llegó la adolescencia a casa práctica,
              honesta, sin juicios y llena de esperanza.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}